import { render, staticRenderFns } from "./FusionPro.vue?vue&type=template&id=8323426e&scoped=true&"
import script from "./FusionPro.vue?vue&type=script&lang=js&"
export * from "./FusionPro.vue?vue&type=script&lang=js&"
import style0 from "./FusionPro.vue?vue&type=style&index=0&id=8323426e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8323426e",
  null
  
)

export default component.exports